import { render, staticRenderFns } from "./CoLeftMainNavigation.vue?vue&type=template&id=521fddf4&scoped=true&"
import script from "./CoLeftMainNavigation.vue?vue&type=script&lang=ts&"
export * from "./CoLeftMainNavigation.vue?vue&type=script&lang=ts&"
import style0 from "./CoLeftMainNavigation.vue?vue&type=style&index=0&id=521fddf4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521fddf4",
  null
  
)

export default component.exports